// extracted by mini-css-extract-plugin
module.exports = {"container":"ContinueHeaderFooter_container__2h0kU"};